/** Theme preference is browser/origin-local. Unmigrated viewer routes stay dark. */
export function portalSupportsTheme(pathname: string | null): boolean {
  return !!pathname && ['/dashboard', '/institutes', '/classes', '/calendar', '/inbox', '/attendance', '/settings', '/join-class', '/sign-in', '/session-recovery', '/rooms']
    .some(path => pathname === path || pathname.startsWith(`${path}/`))
}
export const PORTAL_THEME_CONFIG = {
  attribute: 'class',
  storageKey: 'hikma-theme',
  defaultTheme: 'dark',
  enableSystem: true,
  enableColorScheme: true,
  disableTransitionOnChange: true
} as const
